// Encabezado de la Cotización con extras (REQ-152): equipo neto + extras a crédito = monto a
// financiar, y aparte lo de contado. Sale del reparto del servidor; sin él, la regla vieja. Puro.
import { anchorLineOf } from './buildSale';
import { chargeLinesOf, serverSplitOf } from './saleCharge';
import type { WizardSession } from './types';

export interface QuoteHeadline {
    /** Parte financiada de la ancla: su precio neto. */
    anchorCents: number;
    extrasCents: number;
    /** Lo que se cotiza: ancla + extras a crédito. */
    financedCents: number;
    /** Lo que no entra al crédito; se cobra con el enganche. */
    cashCents: number;
}

/** Monto que cotiza el servidor con el reparto; `undefined` sin reparto (flag apagado). */
export function quotePriceCentsOf(session: WizardSession): number | undefined {
    const split = serverSplitOf(session);
    if (split === undefined) return undefined;
    return [...split.values()].reduce((sum, cents) => sum + cents, 0);
}

/** Encabezado de un crédito con extras; `undefined` sin reparto del servidor o sin extras. */
export function quoteHeadlineOf(session: WizardSession): QuoteHeadline | undefined {
    const split = serverSplitOf(session);
    const anchorId = anchorLineOf(session)?.lineId;
    if (split === undefined || anchorId === undefined) return undefined;
    const hasExtras = (session.reservedLines ?? []).some(
        (l) => l.status === 'RESERVED' && l.lineId !== anchorId && l.role !== 'GIFT',
    );
    if (!hasExtras) return undefined;

    const anchorCents = split.get(anchorId) ?? 0;
    const financedCents = [...split.values()].reduce((sum, cents) => sum + cents, 0);
    const cashCents = chargeLinesOf(session, { credit: true }).reduce(
        (sum, l) => sum + (l.cashCents ?? 0),
        0,
    );
    return { anchorCents, extrasCents: financedCents - anchorCents, financedCents, cashCents };
}
